import {
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  AlignRightOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Input,
  Modal,
  Pagination,
  Popconfirm,
  Popover,
  Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, Link, useParams, useLocation } from "react-router-dom";

import styles from "./styles.css";
import {
  getSubFolder,
  addFolder,
  deleteFolder,
  updateFolder,
  addSubFolder,
  updateSubFolder,
} from "../../../../services/folder";

const SubFolder = ({ dispatch }) => {
  const [folderData, setFolderData] = useState([]);
  const [modal, setModal] = useState({
    visible: false,
    value: "",
    id: "",
    edit: false,
  });
  const history = useHistory();
  const { folderId } = useParams();
  const getFolderFun = () => {
    getSubFolder({
      pathParams: {
        id: folderId,
      },
    }).then((res) => {
      setFolderData(res.folder);
    });
  };
  useEffect(() => {
    getFolderFun();
  }, [folderId]);
  const addFolderFun = () => {
    if (!modal.edit) {
      addSubFolder({
        body: {
          name: modal.value,
        },
        pathParams: {
          id: folderId,
        },
      }).then(() => {
        setModal({
          visible: false,
          value: "",
          id: "",
          edit: false,
        });
        getFolderFun();
      });
    } else if (modal.edit) {
      updateSubFolder({
        body: {
          name: modal.value,
        },
        pathParams: {
          id: modal.id,
        },
      }).then(() => {
        setModal({
          visible: false,
          value: "",
          id: "",
          edit: false,
        });
        getFolderFun();
      });
    }
  };

  return (
    <div className="w-full ">
      <div className="content-panel px-4" style={{}}>
        <div className="mx-4">
          <Breadcrumb style={{ marginBottom: 20 }}>
            <Breadcrumb.Item>
              <Link to="/dashboard">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Folder</Breadcrumb.Item>
          </Breadcrumb>
          <div className="flex justify-between w-full">
            <h1 className="page-heading">All Folder</h1>
            <button
              onClick={() => {
                setModal({
                  visible: true,
                  value: "",
                });
              }}
              className="bg-[#FA6210] h-12 px-5 font-semibold hover:bg-[#15538B]  rounded-md text-white"
            >
              Add Folder
            </button>
          </div>
          <div className="border-b  -mt-4 mb-8" />
        </div>

        <div
          style={{
            display: "flex",
          }}
        >
          {folderData.length === 0 ? (
            <div className="w-full ">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                No Folder
              </h3>
              <p className="text-center my-2">
                There have been no Folder in this section yet
              </p>
              <div className="flex w-full justify-center">
                <Button
                  onClick={() => {
                    setModal({
                      visible: true,
                      value: "",
                    });
                  }}
                >
                  Add Folder
                </Button>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="relative flex flex-wrap">
            {folderData.map((item) => {
              return (
                <div
                  style={{
                    marginLeft: 20,
                    marginBlock: 20,
                    borderRadius: 20,
                    position: "relative",
                  }}
                >
                  <div className="absolute  top-0 right-4  p-2 z-100">
                    <Popover
                      content={
                        <>
                          <Popconfirm
                            title={
                              <div>
                                <div>Are you sure to delete this folder?</div>
                                <div className="text-red-500">
                                  *All the images will be deleted.
                                </div>
                              </div>
                            }
                            onConfirm={() => {
                              deleteFolder({
                                pathParams: {
                                  id: item._id,
                                },
                              }).then(() => {
                                getFolderFun();
                              });
                            }}
                            okText="Delete"
                            cancelText="Cancel"
                            okType="danger"
                          >
                            <DeleteOutlined
                              style={{
                                color: "red",
                                fontSize: 20,
                              }}
                              onClick={() => {}}
                            />
                          </Popconfirm>

                          <EditOutlined
                            onClick={() => {
                              setModal({
                                visible: true,
                                edit: true,
                                value: item.subFolderName,
                                id: item._id,
                              });
                            }}
                            style={{
                              color: "#000",
                              paddingInline: 10,
                              fontSize: 20,
                            }}
                          />
                        </>
                      }
                      trigger="hover"
                    >
                      <AlignRightOutlined />
                    </Popover>
                  </div>
                  <div
                    className="folder-container"
                    onClick={() => {
                      history.push(`/folder/${item._id}`);
                    }}
                  >
                    <div className="folder-icon">
                      <i className="fa fa-folder folder-icon-color"></i>
                    </div>
                    <div className={styles.folder}>
                      <div
                        style={{
                          color: "#fff",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <div className="font-medium text-black text-lg truncate px-3 mt-3">
                          {item.subFolderName}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Modal visible={modal.visible} footer={false} closable={false}>
        <div className="p-3">
          <div className="text-lg font-medium ">Add Folders</div>
          <div className="p-3 my-2">
            <Input
              size="large"
              placeholder="Enter Folder Name"
              value={modal.value}
              onChange={(e) => {
                setModal({
                  ...modal,
                  value: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="flex justify-end p-3">
          <Button
            className="mr-2 "
            onClick={() => {
              setModal({
                visible: false,
                value: "",
                edit: false,
                id: "",
              });
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => {
              addFolderFun();
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default SubFolder;
